module.exports = __webpack_public_path__ + "static/img/shijiu.000828c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/shijiu.png
// module id = 1Z1U
// module chunks = 1